import { Component, OnInit } from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { ConfigurationService } from '../components/configuration-select/configuration.service';
import { PrintService } from '../modules/print/print.service';
import { Configuration } from '../services/Ebootis.Queries/Configuration';
import { LobByOid } from '../services/Ebootis.Queries/LobByOid';

@Component({
  selector: 'app-print-layout',
  templateUrl: './print-layout.component.html',
  styleUrls: ['./print-layout.component.scss']
})
export class PrintLayoutComponent implements OnInit {
  public readonly BRAND_LOGO_FALLBACK: string = './assets/logo.png';
  public m_toolbarImageSrc: string = this.BRAND_LOGO_FALLBACK;
  public m_date;
  private m_subscriptionsSubject = new Subject();
  private m_cfg: Configuration.Result;

  constructor(
    private m_configurationService: ConfigurationService,
    private m_lobByOid: LobByOid,
    private m_printService: PrintService
  ) { }

  ngOnInit() {
    this.m_printService.isPrinting.next(true);
    this.m_date = new Date();
    this.m_configurationService.getConfiguration().pipe(
      takeUntil(this.m_subscriptionsSubject),
    ).subscribe({
      next: (cfg) => {
        this.m_cfg = cfg;
        if (this.m_cfg.logo != null) {
          this.m_toolbarImageSrc = this.m_lobByOid.getLobUrl({ lob: this.m_cfg.logo.oid });
        }
      },
    });
  }

}
